import React from 'react'
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';

export default function Timeline({ section_id, currentIndex = 1 }) {
  const events = [
    { date: '15 October',         label: 'Hackathon Announcement' },
    { date: 'TBD',       label: 'Registration Deadline' },
    { date: '1st week of November',label: 'Webinar 1' },
    { date: '15 - 20 Dec',         label: 'R1 Results' },
    { date: 'Jan 2026',        label: 'Final Event' }
  ]

  // fraction of the bar to color green
  const progressPercent = (currentIndex / (events.length - 1)) * 100

  return (
    <section id={section_id} className="timeline-section">
      <div className="timeline-header">
        {/* <p className="timeline-subtitle title-navy-blue">The Path</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Timeline </h2>
      </div>

      {/* Adding timeline image from canva respin.syspin.web account */}
      <div >
        <img src={application_contants.timeline_r1 } alt="Timeline Illustration" />
      </div>
      {/* <div className="timeline-bar-container">
        <div
          className="timeline-bar-base"
          style={{ width: `${progressPercent}%` }}
        />
        <div className="timeline-bar-base" />
        <div className="timeline-markers">
          {events.map((ev, i) => (
            <div
              key={ev.date}
              className={
                i <= currentIndex
                  ? 'timeline-marker'
                  : 'timeline-marker'
              }
              style={{ left: `${(i / (events.length - 1)) * 100}%` }}
            />
          ))}
        </div>
      </div> */}
{/* 
      <div className="timeline-events">
        {events.map((ev, i) => (
          <div key={ev.date} className="jostRegular h5-small section-title title-dark-grey">
            <strong>{ev.date}</strong><br></br>
            <span>{ev.label}</span>
          </div>
        ))}
      </div> */}
      <br></br> 
      <div className="timeline-header-text">
        <p className="jostRegular h5-small section-title about-text">
          The Challenge will span 1-2 months, providing participants ample time for development, iteration, and refinement of their solutions. The event will be structured into two phases: an initial online round followed by an offline final round.
        </p>
      </div>
    </section>
  )
}

Timeline.propTypes = {
  section_id:   PropTypes.string.isRequired,
  currentIndex: PropTypes.number  // zero-based index of last completed event
}
Timeline.defaultProps = {
  currentIndex: 1  // by default, second event is “active”
}
